
import { baseUrl } from "../../constants";

export default {
    "formTitle": "Add Job Nature",
    "tableTitle": "Job Nature List",
    "apiDetails": {
        startUp: () => {
        },
        list: {
            url: `${baseUrl}/api/system/job_nature/list`,
            payload: {
                "search": "",
                "offset": 0,
                "limit": 50,
                "sort": "DESC"
            }
        },
        add: `${baseUrl}/api/system/job_nature`,
        edit: `${baseUrl}/api/system/job_nature/edit`,
        delete: `${baseUrl}/api/system/job_nature/remove`
    },
    "tableCol": [
        {
            name: 'Nature of Job',
            selector: row => row.jobNature,
            sortable: true
        }
    ],
    "formData": [
        {
            "formType": "flex",
            "formFields": [
                {
                    type: 'text',
                    label: 'Nature of Job',
                    name: 'jobNature',
                    required: true
                }
            ]
        }
    ],
    "mockData": [{
        "jobNature": "sfs"
    }]
}